"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractMetricCollector = void 0;
/**
 * @module Services.MetricCollectors
 */
/**
 * A session metric collector.
 */
var AbstractMetricCollector = /** @class */function () {
  /**
   * Constructor.
   *
   * @param name                       identity
   * @param exportToPrometheus         whether to expose the collector through the Prometheus gateway
   */
  function AbstractMetricCollector(name, exportToPrometheus, maximumGroups) {
    if (maximumGroups < 1) {
      throw new Error("maximumGroups must be positive: " + maximumGroups);
    }
    this.name = name;
    this.maximumGroups = maximumGroups;
    this.exportToPrometheus = exportToPrometheus;
  }
  return AbstractMetricCollector;
}();
exports.AbstractMetricCollector = AbstractMetricCollector;